var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "review-radio-stats" },
    [
      _c("input-group-head", {
        attrs: { label: _vm.label, error: _vm.error, large: "" }
      }),
      _c("radio-group", {
        attrs: {
          value: _vm.value,
          options: _vm.options,
          "error-mode": !!_vm.error,
          name: "size"
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }